import { nextTick, ref, set } from 'vue'

export function useTableSelectionPanel({ result, tableData }) {
  const tablePanelRef = ref(null)

  const toggleResultItem = (row) => {
    const index = result.value.findIndex((item) => item.id === row.id)
    if (index > -1) {
      result.value.splice(index, 1)
    } else {
      result.value.push(row)
    }
  }

  const batchUpdateResult = (rows, isAdd) => {
    if (isAdd) {
      rows.forEach((row) => {
        const exists = result.value.some((item) => item.id === row.id)
        if (!exists) {
          result.value.push(row)
        }
      })
      return
    }
    const idsToRemove = new Set(rows.map((item) => item.id))
    result.value = result.value.filter((item) => !idsToRemove.has(item.id))
  }

  const onTableRowSelect = (selection, row) => {
    toggleResultItem(row)
  }

  const onTableSelectAll = (selection) => {
    const isSelectAll = selection.length > 0
    if (isSelectAll) {
      batchUpdateResult(tableData.value, true)
    } else {
      batchUpdateResult(tableData.value, false)
    }
  }

  const restoreSelection = () => {
    nextTick(() => {
      if (tablePanelRef.value && tableData.value.length && result.value.length) {
        result.value.forEach((res) => {
          const row = tableData.value.find((item) => item.id === res.id)
          if (row) {
            tablePanelRef.value.toggleRowSelection(row, true)
          }
        })
      }
    })
  }

  const onResItemRemove = ({ id }, index) => {
    tableData.value.forEach((item) => {
      if (item.id === id && tablePanelRef.value) {
        tablePanelRef.value.toggleRowSelection(item, false)
      }
    })
    result.value.splice(index, 1)
  }

  const clearAll = () => {
    result.value = []
    tableData.value.forEach((item) => {
      if (tablePanelRef.value) {
        tablePanelRef.value.toggleRowSelection(item, false)
      }
    })
  }

  const getSelectData = () => {
    return result.value
  }

  return {
    tablePanelRef,
    restoreSelection,
    onTableRowSelect,
    onTableSelectAll,
    toggleResultItem,
    batchUpdateResult,
    onResItemRemove,
    clearAll,
    getSelectData
  }
}
